import React from "react";
import "../css/about.scss";

function About() {
  return (
    <div className="about-page">
      <div className="container">
        <h1>Our Story</h1>
        <div className="content-section">
          <p>
            Cewillow Market is an online destination for easy fashion, useful
            accessories, home details and thoughtful gifts. Our collection is
            shaped around pieces that are practical, expressive and simple to
            enjoy every day.
          </p>
          <p>
            We look for considered colours, tactile materials and uncomplicated
            forms. Each item is reviewed for how it looks, feels and functions
            before it becomes part of the Cewillow Market edit.
          </p>
          <p>
            Our range moves between clothing, fragrance, décor and lifestyle
            essentials, but the aim stays the same: make it easier to find
            distinctive pieces that work well together.
          </p>
          <p>
            Questions about a product or order are always welcome. Contact us at
            import@cewillowmarket.life and our support team will be happy to help.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
